module.exports = __webpack_public_path__ + "img/logo-iotracker-light.27e9f574.svg";